import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { computed } from 'vue'

  // Icons
  import FixedPaymentIcon from '@/assets/FixedPaymentIcon.vue'

  // Components
  import BasePaymentCondition from './BasePaymentCondition.vue'
  import TermsAndConditionsLink from '@/components/common/TermsAndConditionsLink.vue'

  // Translations
  import { useI18n } from 'vue-i18n'
  import { isTravelskiExpress as checkIsTravelskiExpress } from '@/config'
  import { TRAVELSKI_EXPRESS_TERMS_URL } from '@/config/termsAndConditions'

  interface Props {
    prestId: number
    liheId: number
    liheName?: string
    packageCode?: string
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'FixedPaymentCondition',
  props: {
    prestId: {},
    liheId: {},
    liheName: {},
    packageCode: {}
  },
  setup(__props: any) {

  // Vue
  const { t } = useI18n()

  // Config
  const props = __props

  // Check if this is a Travelski Express booking
  const isTravelskiExpress = computed(() => {
    return checkIsTravelskiExpress(props.liheId, props.liheName, props.packageCode)
  })

return (_ctx: any,_cache: any) => {
  return (isTravelskiExpress.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(TermsAndConditionsLink, {
          linkText: _unref(t)('payments.termsAndConditions'),
          "custom-url": _unref(TRAVELSKI_EXPRESS_TERMS_URL)
        }, null, 8, ["linkText", "custom-url"])
      ]))
    : (_openBlock(), _createBlock(BasePaymentCondition, {
        key: 1,
        "border-class": "orange-border",
        "text-class": "text-primary-orange"
      }, {
        "payment-condition-icon": _withCtx(() => [
          _createVNode(FixedPaymentIcon)
        ]),
        "payment-condition-type": _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('payments.fixedProduct')), 1)
        ]),
        "payment-condition__title__ref": _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('payments.fixedTitle')), 1)
        ]),
        "payment-condition-description": _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('payments.fixedDescription')), 1)
        ]),
        _: 1
      }))
}
}

})